/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import {
  GET_CIRCULARS_REQUEST,
  GET_CIRCULARS_SUCCESS,
  GET_CIRCULARS_FAILURE,
  CREATE_CIRCULAR_REQUEST,
  CREATE_CIRCULAR_SUCCESS,
  CREATE_CIRCULAR_FAILURE,
  UPDATE_CIRCULAR_REQUEST,
  UPDATE_CIRCULAR_SUCCESS,
  UPDATE_CIRCULAR_FAILURE,
  DELETE_CIRCULAR_REQUEST,
  DELETE_CIRCULAR_SUCCESS,
  DELETE_CIRCULAR_FAILURE,
} from "./circularTypes";

import axios from "axios";
import Config from "../../config/index";
let baseUrl = Config.baseUrl;
// let baseUrl = `http://13.71.2.248:1338/api/v2/users_management`;

const getCircularsRequest = () => {
  return {
    type: GET_CIRCULARS_REQUEST,
  };
};

const getCircularsSuccess = (payload) => {
  return {
    type: GET_CIRCULARS_SUCCESS,
    payload: payload,
  };
};

const getCircularsFaliure = (error) => {
  return {
    type: GET_CIRCULARS_FAILURE,
    payload: error,
  };
};

const getCirculars = (status, pageNo, rowsPerPage, search, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getCircularsRequest());
    let url = `${baseUrl}/circular/get_all?status=${status}&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&download=0`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getCircularsSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getCircularsFaliure(err.response));
      });
  };
};

const getCircularsForHomeRequest = () => {
  return {
    type: GET_CIRCULARS_REQUEST,
  };
};

const getCircularsForHomeSuccess = (payload) => {
  return {
    type: GET_CIRCULARS_SUCCESS,
    payload: payload,
  };
};

const getCircularsForHomeFaliure = (error) => {
  return {
    type: GET_CIRCULARS_FAILURE,
    payload: error,
  };
};

const getCircularsForHome = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getCircularsForHomeRequest());
    let url = `${baseUrl}/circular/get`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getCircularsForHomeSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getCircularsForHomeFaliure(err.response));
      });
  };
};

const createCircularRequest = () => {
  return {
    type: CREATE_CIRCULAR_REQUEST,
  };
};

const createCircularSuccess = (payload) => {
  return {
    type: CREATE_CIRCULAR_SUCCESS,
    payload: payload,
  };
};

const createCircularFaliure = (error) => {
  return {
    type: CREATE_CIRCULAR_FAILURE,
    payload: error,
  };
};

const createCircular = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(createCircularRequest());
    let url = `${baseUrl}/circular/create`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createCircularSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createCircularFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const updateCircularRequest = () => {
  return {
    type: UPDATE_CIRCULAR_REQUEST,
  };
};

const updateCircularSuccess = (payload) => {
  return {
    type: UPDATE_CIRCULAR_SUCCESS,
    payload: payload,
  };
};

const updateCircularFaliure = (error) => {
  return {
    type: UPDATE_CIRCULAR_FAILURE,
    payload: error,
  };
};

const updateCircular = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(updateCircularRequest());
    let url = `${baseUrl}/circular/update`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(updateCircularSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(updateCircularFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const deleteCircularRequest = () => {
  return {
    type: DELETE_CIRCULAR_REQUEST,
  };
};

const deleteCircularSuccess = (payload) => {
  return {
    type: DELETE_CIRCULAR_SUCCESS,
    payload: payload,
  };
};

const deleteCircularFaliure = (error) => {
  return {
    type: DELETE_CIRCULAR_FAILURE,
    payload: error,
  };
};

const deleteCircular = (circularId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(deleteCircularRequest());
    let url = `${baseUrl}/circular/delete?id=${circularId}`;
    return axios
      .delete(url, headers)
      .then((response) => {
        dispatch(deleteCircularSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(deleteCircularFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

export {
  getCirculars,
  createCircular,
  updateCircular,
  deleteCircular,
  getCircularsForHome,
};
